import { render, staticRenderFns } from "./OrderHomePage.vue?vue&type=template&id=7fce4154&scoped=true"
import script from "./OrderHomePage.vue?vue&type=script&lang=js"
export * from "./OrderHomePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fce4154",
  null
  
)

export default component.exports